
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import { cal } from "@/utils/cal";
import { QuotationApprovalDetail, QuotationApproval } from "./types";

import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";

// import { cloneDeep } from "lodash";
import { getContainerType } from "@/api/container-type";
import { getUsersByJobPosition } from "@/api/users";
import {
  getQuotationDetail,
  auditHold,
  auditCancelHold,
  removeQuotation,
  getQuotationStatus,
  auditPass,
  getConversionExchangeRate,
  getDraftPriceType,
  getRecordsStatus,
  getAuditHoldRemark,
} from "@/api/inquiry";

import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { log } from "console";
import GenerateAppendPiDialog from "./components/GenerateAppendPiDialog.vue";
// import { isShallow } from "vue";

@Component({
  name: "quotationDetails",
  components: {
    Pagination,
    GenerateAppendPiDialog,
  },
})
export default class extends Vue {
  private tableLoading = false;
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();
  private generateAppendPiVisible = false;

  private conversionExchangeRate = 0;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as QuotationApprovalDetail[],
  };
  private listParam = {
    approvalRecordId: null,
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    productName: null,
    type: null,
  };
  public searchForm = [
    {
      label: "号码查询",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入产品号码",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      type: "input",
      value: "",
      placeholder: "请输入PRODUCT NAME",
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "参照号类型",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "品牌名称",
      prop: "brandName",
      key: "brandName",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "采购折后单价(CNY)",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      // key2: "purchaseUnitPrice",
      show: true,
      disabled: false,
      type: "discount",
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      show: true,
      disabled: false,
      type: "status",
      width: 100,
      show_key: "show1",
    },
    // {
    //   label: "目录价格（CNY）",
    //   prop: "shippingCode",
    //   key: "shippingCode",
    //   show: true,
    //   disabled: false,
    // },
    {
      label: "采购总价",
      prop: "purchaseTotalPrice",
      key: "purchaseTotalPrice",
      show: true,
      disabled: false,
    },
    {
      label: "销售折后单价",
      prop: "saleDiscountUnitPrice",
      key: "saleDiscountUnitPrice",
      // key2: "saleUnitPrice",
      show: true,
      disabled: false,
      type: "discount",
      account: ['A','A_B'],
    },
    {
      label: "公司定价",
      prop: "companyPrice",
      key: "companyPrice",
      show: true,
      disabled: false,
      width: 140,
      account: ['B','A_B']
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "销售总报价",
      prop: "saleTotalPrice",
      key: "saleTotalPrice",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "销售总定价",
      prop: "companyTotalPrice",
      key: "companyTotalPrice",
      show: true,
      disabled: false,
      account: ['B','A_B'],
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "折算利润额",
      prop: "conversionProfitAmount",
      key: "conversionProfitAmount",
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
  ] as any;
  public customerInfo = {} as QuotationApproval;
  public customerInfoRemark = "" as string;
  public customerStatus = "";
  public customerInfoFields = [
    {
      label: "客人信息",
      key: "customerAbbreviation",
      render: (prop, row)=>{
        if (row.pcName && row.pcName.length > 0){
          return `[${row.pcName}]${prop}`
        }
        return prop
      }
    },
    {
      label: "下单时间",
      key: "createdTime",
    },
    {
      label: "挂起备注",
      key: "remark",
    },
    {
      label: "产品总数量",
      key: "productQuantity",
    },
    {
      label: "采购总价",
      key: "purchaseTotalPrice",
    },
    {
      label: "销售总金额",
      key: "saleTotalPrice",
      account:['A','A_B']
    },
    {
      label: "销售总定价",
      key: "totalAmountByCompanyPrice",
      account:['B','A_B']
    },
    {
      label: "整单折算利润率",
      key: "conversionProfitMargin",
      account:['A','A_B']
    },
    {
      label: "折算利润总额",
      key: "conversionProfitAmount",
      account:['A','A_B']
    },
    {
      label: "当前状态",
      key: "status",
    },
  ] as any;
  get showPI() {
    return this.customerStatus === "审批通过";
  }
  get showHold() {
    return this.customerStatus === "待审核";
  }
  get showCancelHold() {
    return this.customerStatus === "已挂起";
  }
  get showPass() {
    return "待审核,已挂起".indexOf(this.customerStatus) > -1 ? true : false;
  }
  get showCheck() {
    return (
      this.showHold ||
      this.showPass ||
      this.showCancelHold ||
      this.showCancelHold
    );
  }
  created() {
    this.listParam.inquirySheetId = this.$route.query.id as string;
    let mid_item: string = this.$route.query.item as string;
    if (mid_item.indexOf("replace") != -1) {
      this.customerInfo = JSON.parse(mid_item.replace("replace", "&"));
      this.customerInfoRemark = JSON.parse(
        mid_item.replace("replace", "&")
      ).remark;
    } else {
      this.customerInfo = JSON.parse(this.$route.query.item as string);
      this.customerInfoRemark = JSON.parse(
        this.$route.query.item as string
      ).remark;
    }
    this.customerInfoRemark = JSON.parse(
      this.$route.query.item as string
    ).remark;
    this.init();
  }

  activated() {
    this.init();
  }
  private init() {
    this.getRecordsStatus();
    this.getDraftPriceType();
    this.getConversionExchangeRate();
    this.getList();
  }

  private async getRemark(id) {
    let params = {
      id: id,
    };
    const res = await getAuditHoldRemark(params);
    console.log("resresresres", res);
    this.customerInfo.remark = res as any;
  }
  private async getRecordsStatus() {
    const res: any = await getRecordsStatus(this.customerInfo.approvalRecordId);
    this.customerStatus = res.data || res;
  }

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    let index = this.tableCol.findIndex((item) => {
      return item.key === "unitPriceType";
    });
    this.tableCol[index].typeList = res;
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }
  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }
  public handleCommand(command) {
    this[command]();
  }
  private cancelAuditHold() {
    this.$confirm("确定取消挂起吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditCancelHold({
          id: this.customerInfo.approvalRecordId,
        });
        this.$notify({
          title: "成功",
          message: "取消成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private editAuditHold() {
    this.$prompt("请输入挂起原因", "编辑挂起原因", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputValue: this.customerInfoRemark, // 默认值
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "编辑挂起原因成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
        this.getRemark(this.$route.query.approvalRecordId);
      })
      .catch(() => {
        // empty
      });
  }
  // 挂起
  private async handleAuditHold() {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "挂起成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }
  // 审核通过
  public async handleAuditPass() {
    this.$confirm("确定审核通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(this.customerInfo.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审核通过",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  //  生成/追加PI
  private openGenerateAppendPiDialog() {
    this.generateAppendPiVisible = true;
  }

  private onGenerateAppendPiSuccess() {
    this.getRecordsStatus();
    this.getList();
  }
  public loading: Boolean = false;
  private async getList() {
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
      approvalRecordId: this.customerInfo.approvalRecordId,
    };
    this.loading = true;
    this.listLoading = false;
    this.tableLoading = true;
    await getQuotationDetail(params).then(res => {
      const { total, list }: any = res
      this.table.total = +total;
      this.table.list = list;
      this.tableLoading = false;
      setTimeout(() => {
        this.listLoading = false;
      }, 0.3 * 1000);
    }).catch(err =>{
      console.log(err);
      this.tableLoading = false;
    });
  }
  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = this.getDiscount(item.purchaseDiscount);
    let purchaseDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, purchaseDiscount),
      +item.purchaseUnitPrice
    );
    purchaseDiscountUnitPrice = purchaseDiscountUnitPrice.toFixed(2) as any;
    this.$set(item, "purchaseDiscountUnitPrice", purchaseDiscountUnitPrice);
    // 获取采购总价
    let purchaseTotalPrice = +cal.cheng(
      purchaseDiscountUnitPrice,
      item.productQuantity
    );
    purchaseTotalPrice = purchaseTotalPrice.toFixed(2) as any;
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
    // saleDiscount
    const saleDiscount = this.getDiscount(item.saleDiscount);
    // saleUnitPrice
    let saleDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, saleDiscount),
      item.saleUnitPrice
    );
    saleDiscountUnitPrice = saleDiscountUnitPrice.toFixed(2) as any;
    this.$set(item, "saleDiscountUnitPrice", saleDiscountUnitPrice);
    const saleTotalPrice = (
      item.saleDiscountUnitPrice * item.productQuantity
    ).toFixed(2);
    this.$set(item, "saleTotalPrice", saleTotalPrice);
    // 折算利润率
    // this.calculateConversionProfitMargin(item);
    this.computedTotalAmount(item);
  }
  /**
   * 折算利润率
   */
  private calculateConversionProfitMargin(item: any) {
    const purchasePrice = item.purchaseTotalPrice;
    const salesRevenue =
      item.saleDiscountUnitPrice *
      item.productQuantity *
      this.conversionExchangeRate;
    if (
      !Number.isFinite(purchasePrice) ||
      !Number.isFinite(salesRevenue) ||
      purchasePrice <= 0
    ) {
      return null;
    }
    const profitRate = ((salesRevenue - purchasePrice) / purchasePrice).toFixed(
      2
    );
    // console.log(profitRate);
    this.$set(item, "conversionProfitMargin", profitRate);
  }
  private getDiscount(val) {
    if (val.indexOf("%") === -1) {
      return val;
    }
    const discountDecimal = parseFloat(val) / 100;
    return discountDecimal;
  }
  // 折算汇率
  private async getConversionExchangeRate() {
    const res: any = await getConversionExchangeRate({});
    this.conversionExchangeRate = +res.conversionExchangeRateUsd;
  }
  // 销售总金额 * 折算汇率 = 销售总金额（人民币）
  // 折算利润额 = 销售总金额（人民币）- 采购总价
  // 计算折算利润额
  private computedTotalAmount(item) {
    let conversionProfitAmount = 0;
    const { saleTotalPrice, purchaseTotalPrice } = item;
    const { conversionExchangeRate } = this;
    conversionProfitAmount = (
      conversionExchangeRate * saleTotalPrice -
      purchaseTotalPrice
    ).toFixed(2) as any;
    this.$set(item, "conversionProfitAmount", conversionProfitAmount);
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }
  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }
  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
  }
  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
